// extracted by mini-css-extract-plugin
export default {"result":"result___Fv5wc","resultIcon":"resultIcon___NAZlP","up":"up___zvsgP","down":"down___CuOeb","result-text":"result-text___o4HIs"};